<template>
  <v-card>
    <v-card-title class="font-weight-bold blueBackground white--text pa-2">
      <span>{{ selectedDate | dateFormat }}</span>

      <v-btn
        :loading="resetClicked"
        :disabled="resetClicked"
        @click="resetTimesheetEntry"
        small
        color="pipefishOrange"
        class="ml-3 my-0"
        v-if="
          userProfile.IsAdmin &&
            formData.ApprovalId &&
            userProfile.id != submitEntryFor.id
        "
      >
        reset
        <v-icon>mdi-refresh</v-icon>
      </v-btn>
      <v-spacer />
      <v-icon @click="close" color="white" medium
        >mdi-close-circle-outline</v-icon
      >
    </v-card-title>
    <v-card-text style="paddingTop: 0px; border: 0px solid blue">
      <v-tooltip right color="pipefishBlack">
        <template v-slot:activator="{ on }">
          <v-checkbox
            v-on="on"
            hide-details
            v-model="saveDefault"
            style="padding: 0px; margin: 0px"
            label="Save as favourite"
          ></v-checkbox>
        </template>
        <span style="color:white">
          Save this entry as your favourite
          <br />to fill a week
        </span>
      </v-tooltip>
      <v-form ref="form" v-model="valid">
        <v-container grid-list-md style="padding:0px">
          <v-layout wrap>
            <v-flex grow>
              <v-date-picker v-model="selectedDate" @change="isDirty">
                <v-text-field
                  :disabled="isLocked"
                  slot-scope="props"
                  label="Date"
                  v-model="props.inputValue"
                  append-icon="mdi-calendar-range"
                  readonly
                  :rules="[!!selectedDate || 'Select a date']"
                ></v-text-field>
              </v-date-picker>
            </v-flex>
            <v-flex xs12 sm6 md4>
              <v-text-field
                :disabled="isLocked"
                label="Hours"
                type="number"
                append-outer-icon="mdi-clock"
                v-model.number="selectedHours"
                :rules="[
                  !!selectedHours || 'Hours need to be entered',
                  selectedHours > 0 || 'Hours need to be positive',
                  selectedHours <= 24 || 'Seriously??',
                ]"
                @change="isDirty"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6>
              <v-select
                :disabled="isLocked"
                :items="displayClients"
                label="Select a Client"
                v-model="selectedClient"
                :rules="[!!selectedClient || 'A client needs to be selected']"
                @change="changed('Client')"
              ></v-select>
            </v-flex>
            <v-flex xs12 sm6>
              <v-select
                :disabled="isLocked"
                :items="displayProjects"
                label="Select a Project"
                v-model="selectedProject"
                :rules="[!!selectedProject || 'A project needs to be selected']"
              ></v-select>
            </v-flex>
            <v-flex xs12 sm10>
              <v-select
                :disabled="isLocked"
                :items="activities"
                label="Select an Activity"
                v-model="selectedActivity"
                :rules="[
                  !!selectedActivity || 'An activity needs to be selected',
                ]"
                @change="isDirty"
              ></v-select>
            </v-flex>
            <v-flex xs12 sm2>
              <v-text-field
                label="Practice Code"
                placeholder="Practice"
                readonly
                v-model="displayPractice"
              ></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-textarea
                :disabled="isLocked"
                hide-details
                outline
                label="Notes"
                color="pipefishGreen"
                v-model="enteredNotes"
                @change="isDirty"
              ></v-textarea>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-container grid-list-md style="padding:0px">
        <v-layout row wrap>
          <v-flex class="shrink">
            <div class="locked-container">
              <div
                class="locked-navi font-weight-bold rotate-30"
                style="color: red"
                v-if="isLocked"
              >
                LOCKED
              </div>
              <div class="locked-infoi">
                <v-btn v-if="isNewEntry" color="pipefishOrange" @click="close"
                  >Close</v-btn
                >
                <v-btn
                  v-else
                  color="pipefishOrange"
                  @click="deleteEntry"
                  :disabled="isLocked"
                  >Delete</v-btn
                >
              </div>
            </div>
          </v-flex>
          <v-spacer />

          <v-flex class="shrink">
            <v-menu
              bottom
              origin="center center"
              transition="scale-transition"
              :close-on-content-clock="true"
            >
              <template v-slot:activator="{ on }">
                <v-tooltip dark top color="pipefishBlack">
                  <template v-slot:activator="{ on }">
                    <v-icon right medium v-on="on"
                      >mdi-information-outline</v-icon
                    >
                  </template>
                  <span style="color:white">
                    Use Favourite Entry OR
                    <br />Save as Favourite entry for filing the whole week
                  </span>
                </v-tooltip>
                <v-btn color="indigo" dark v-on="on">Pre-fill Options</v-btn>
                
              </template>
              <v-card>
                <v-container style="padding: 0px !important;">
                  <v-layout row>
                    <v-card-actions>
                      <v-btn
                        small
                        :loading="lastEntryClicked"
                        color="pipefishBlack"
                        @click="fillWithRecentEntry"
                        :disabled="lastEntryClicked"
                        >Use Favourite Entry</v-btn
                      >
                    </v-card-actions>
                  </v-layout>
                  <v-layout row>
                    <v-card-actions>
                      <v-btn
                        v-if="isNewEntry"
                        color="pipefishBlack"
                        small
                        @click="fillWeek"
                        >Fill Week</v-btn
                      >
                    </v-card-actions>
                  </v-layout>
                </v-container>
              </v-card>
            </v-menu>
          </v-flex>

          <v-flex class="shrink">
            <div>
              <div class="locked-container">
                <div
                  class="locked-navi font-weight-bold rotate-30"
                  style="color: red"
                  v-if="isLocked"
                >
                  LOCKED
                </div>
                <div class="locked-infoi">
                  <v-btn
                    color="pipefishGreen"
                    :loading="submitClicked"
                    @click="submitEntry"
                    :disabled="submitClicked || !valid || isLocked"
                    >Save</v-btn
                  >
                </div>
              </div>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-actions>
  </v-card>
</template>

<script>
import moment from "moment";
import { mapState } from "vuex";

export default {
  props: ["formData", "isNewEntry", "submitEntryFor"],
  data: () => ({
    resetClicked: false,
    saveDefault: false,
    valid: true,
    lastEntryClicked: false,
    submitClicked: false,
    selectedProject: null,
    selectedDate: null,
    selectedClient: null,
    selectedActivity: null,
    isOnsite: false,
    selectedHours: null,
    enteredNotes: "",
    dirtyForm: false,
  }),
  computed: {
    ...mapState("api", ["timesheetData"]),
    ...mapState("app", ["userProfile"]),
    isLocked: function() {
      return this.formData.approval != null;
    },
    displayClients: function() {
      return this.timesheetData
        .filter((client) => client.IsActive)
        .map((client) => ({ text: client.Name, value: client }))
        .sort((a, b) => a.text.localeCompare(b.text));
    },
    displayProjects: function() {
      if (this.selectedClient) {
        return this.selectedClient.projects
          .filter((project) => project.IsActive)
          .map((project) => ({ text: project.Name, value: project }))
          .sort((a, b) => a.text.localeCompare(b.text));
      }
      return [];
    },
    activities: function() {
      if (this.selectedProject) {
        return this.selectedProject.activities
          .filter((activity) => activity.IsActive)
          .map((activity) => ({ text: `${activity.Name}`, value: activity }))
          .sort((a, b) => a.text.localeCompare(b.text));
      }
      // No project is selected, so no activities
      return [];
    },
    displayPractice: function() {
      if (this.selectedActivity) {
        return this.selectedActivity.practice.Code;
      }
      return "";
    },
  },
  watch: {
    formData: function(newD, old) {
      this.selectedDate = new Date(newD.WorkedOn);
    },
  },
  created() {
    if (!this.isNewEntry) {
      this.populateFormData();
    }
    this.selectedDate = new Date(this.formData.WorkedOn);
    this.dirtyForm = false;
  },
  filters: {
    dateFormat(value) {
      return moment(value).format("dddd, D MMMM");
    },
  },
  methods: {
    isDirty() {
      this.dirtyForm = true;
    },
    changed(option) {
        switch (option) {
          case "Client":
            this.selectedProject = null;
            this.selectedActivity = null;
            break;
          case "Project":
            this.selectedActivity = null;
            break;
          default:
            this.selectedClient = this.selectedProject = this.selectedActivity = null;
            break;
      }

      this.isDirty();
    },

    submitEntry() {
      if (!this.$refs.form.validate()) {
        // console.log("Some fields are empty or invalid");
        return;
      }

      //TODO: There is a problem with form validation, doesn't fully work
      // If user select a client then project and then selects differnet client,
      // the view shows selected project as empty, however selectedProject is not empty
      // so during validation it think its not empty

      // If form validation is successful then submit or save entry
      var workingDate = moment.utc([
        this.selectedDate.getFullYear(),
        this.selectedDate.getMonth(),
        this.selectedDate.getDate(),
      ]);

      var toSubmit = {
        ClientId: this.selectedClient.id,
        ProjectId: this.selectedProject.id,
        ActivityId: this.selectedActivity.id,
        PracticeId: this.selectedActivity.practice.id,
        UserAccountId: this.submitEntryFor.id,
        WorkedOn: workingDate,
        HoursWorked: this.selectedHours,
        Onsite: this.isOnsite,
        Notes: this.enteredNotes,
        ModifiedBy: this.userProfile.id,
        ModifiedOn: new Date(),
        Status: "submitted",
        StatementId: this.selectedActivity.statement.Id,
        StatementName: this.selectedActivity.statement.Name,
      };
      var self = this;
      this.submitClicked = true;
      // update recent entry only for activities that are not leave
      // if(!this.selectedActivity.IsLeave) {
      if (this.saveDefault) {
        this.$timesheetApi.updateRecentEntry(toSubmit).then((recent) => {
          self.saveDefault = false;
          // console.log(recent);
        });
      }

      if (this.isNewEntry) {
        this.$timesheetApi
          .submitEntry(toSubmit)
          .then((response) => {
            // close the dialog box and display some notification? maybe a snack bar
            // console.log(response);
            self.$emit("save", "Submitted timesheet entry successfully");
            self.submitClicked = false;

            // TODO: confirm this is a ok way to deal with the issue
            // Emit another event so that all entries can be fetched again
            self.selectedProject = null;
            self.selectedDate = null;
            self.selectedClient = null;
            self.selectedActivity = null;
            self.selectedHours = null;
            self.selectedDate = new Date(self.formData.WorkedOn);
            self.enteredNotes = "";
            self.$refs.form.resetValidation();
          })
          .catch((err) => {
            console.log(err);
            console.log("Request Timeout");
            self.submitClicked = false;
          });
      } else {
        // this is an existing entry
        // when save is pressed, need to update this record
        this.$timesheetApi
          .updateEntry(toSubmit, this.formData.id)
          .then((response) => {
            // console.log(response);
            self.$emit("save", "Timesheet entry updated successfully");
            self.submitClicked = false;
          })
          .catch((err) => {
            console.log("Request Timeout");
            self.submitClicked = false;
            self.saveDefault = false;
          });
      }
    },
    deleteEntry() {
      // Delete this entry
      var self = this;
      this.$timesheetApi.deleteEntry(this.formData.id).then((response) => {
        // console.log(response);
        self.$emit("delete");
      });
    },
    close() {
      if (this.dirtyForm) {
        if (!confirm("This entry has been updated, do you wish to close?")) {
          return;
        }
      }
      // Reset all the values
      if (this.isNewEntry) {
        this.selectedProject = null;
        this.selectedDate = null;
        this.selectedClient = null;
        this.selectedActivity = null;
        this.selectedHours = null;
        this.selectedDate = new Date(this.formData.WorkedOn);
        this.enteredNotes = "";
      } else {
        this.populateFormData();
      }
      this.$refs.form.resetValidation();
      this.$emit("close");
    },
    getClient(id) {
      var foundClient = this.timesheetData.find((client) => {
        return client.id == id;
      });
      return foundClient;
    },
    getProject(id, projects) {
      var foundProject = projects.find((project) => {
        return project.id == id;
      });
      return foundProject;
    },
    getActivity(id, activities) {
      var foundActivity = activities.find((activity) => {
        return activity.id == id;
      });
      return foundActivity;
    },
    populateFormData() {
      this.selectedDate = new Date(this.formData.WorkedOn);
      this.selectedClient = this.getClient(this.formData.clientId);
      this.selectedProject = this.getProject(
        this.formData.projectId,
        this.selectedClient.projects
      );
      this.selectedActivity = this.getActivity(
        this.formData.activityId,
        this.selectedProject.activities
      );
      this.selectedHours = this.formData.HoursWorked;
      this.isOnsite = this.formData.Onsite;
      this.enteredNotes = this.formData.Notes;
      this.dirtyForm = false;
    },
    fillWithRecentEntry() {
      this.lastEntryClicked = true;
      var self = this;
      this.$timesheetApi.getRecentEntry(this.submitEntryFor.id).then(
        (response) => {
          self.populateFields(response);
          self.lastEntryClicked = false;
        },
        (err) => {
          self.lastEntryClicked = false;
          console.log("No Recent Entry in the dB");
        }
      );
    },
    fillWeek() {
      var days = [];
      var self = this;
      this.submitClicked = true;

      var startingMonday = moment.utc(this.selectedDate).startOf("isoWeek");
      var day = startingMonday;
      for (var i = 0; i < 5; i++) {
        days.push(new Date(day));
        day = day.clone().add(1, "d");
      }

      this.$timesheetApi
        .submitMultipleEntries(
          this.userProfile.id,
          this.submitEntryFor.id,
          days
        )
        .then((response) => {
          // console.log(response);
          self.$emit("save", "Saved timesheets for the week successfully");
          self.submitClicked = false;

          // TODO: confirm this is a ok way to deal with the issue
          // Emit another event so that all entries can be fetched again
          self.selectedProject = null;
          self.selectedDate = null;
          self.selectedClient = null;
          self.selectedActivity = null;
          self.selectedHours = null;
          self.selectedDate = new Date(self.formData.WorkedOn);
          self.enteredNotes = "";
          self.$refs.form.resetValidation();
        });
    },
    /* Fill with recent entry data  */
    populateFields(entryData) {
      // this.selectedDate = new Date(this.entryData.WorkedOn)
      this.selectedClient = this.getClient(entryData.clientId);
      this.selectedProject = this.getProject(
        entryData.activity.project.Id,
        this.selectedClient.projects
      );
      this.selectedActivity = this.getActivity(
        entryData.activity.Id,
        this.selectedProject.activities
      );
      console.log(this.getActivity(entryData.activity.Id, this.selectedProject.activities));
      this.selectedHours = entryData.HoursWorked;
      this.isOnsite = entryData.Onsite;
      this.enteredNotes = entryData.Notes;
      this.dirtyForm = false;
    },
    resetTimesheetEntry() {
      var self = this;
      self.resetClicked = true;
      this.$timesheetApi
        .resetTimesheetEntry(this.formData.ApprovalId)
        .then((response) => {
          // console.log(response);
          self.resetClicked = false;
          self.$emit("save", "Timesheets are now unlocked");
        });
    },
  },
};
</script>

<style>
.rotate-30 {
  transform: rotate(-30deg);
}
.locked-container {
  width: 100px;
  height: 40px;
  position: relative;
}
.locked-navi,
.locked-infoi {
  position: absolute;
  top: 0;
  left: 0;
}
.locked-infoi {
  z-index: 10;
}
</style>
